import { useContext } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { UserContext } from '../../context/UserContext';
import { GetConsentResponse, getConsent, saveConsent } from '../../services/consent.service';
import { queryKeys } from '../queryKeyFactory';

interface UseConsentResult {
  isLoading: boolean;
  isError: boolean;
  consent?: GetConsentResponse;
  accept: () => void;
}

export const useConsent = (): UseConsentResult => {
  const { csUserId: userId } = useContext(UserContext);
  const queryClient = useQueryClient();
  const {
    data: consent,
    isLoading,
    isError,
  } = useQuery([queryKeys.consent.getConsent], () => getConsent({ userId }), { enabled: !!userId });

  const { mutate: accept } = useMutation(() => saveConsent({ userId, configurationId: consent?.configuration?.id }), {
    onSettled: () => {
      queryClient.invalidateQueries([queryKeys.consent.getConsent]);
    },
  });

  return {
    isLoading,
    isError,
    consent,
    accept,
  };
};
